import { menuData } from "../utils";
import { motion } from "framer-motion";
import { fadeIn } from "../utils";
import { MenuCard } from "./MenuCard";

export const Menu = () => {
  const { title, subtitle, menuItems, modelImg, btnText } = menuData;

  return (
    <section className="min-h-[700px]">
      <div id='menu' className="h-[780px] bg-menu absolute w-full max-w-[1800px] -z-0">
        <div className="relative z-10 top-72 lg:top-52">
          <motion.div
            initial='hidden'
            whileInView='show'
            viewport={{ once: false, amount: 0.1 }}
            className="conatiner mx-auto flex flex-col items-center text-center"
          >
            <motion.h2 variants={fadeIn('down', 'tween', 0.2, 1.6)} className="h2 capitalize text-white max-w-[400px] text-center">{title}</motion.h2>

            <motion.p variants={fadeIn('down', 'tween', 0.4, 1.6)} className="text-white/70 capitalize mb-8">{subtitle}</motion.p>

            <motion.div variants={fadeIn('down', 'tween', 0.6, 1.6)}>
              <img src={modelImg} alt="" />
            </motion.div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 150 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ type: 'tween', delay: 0.2, duration: 1.6, ease: 'easeOut' }}
          className="relative top-80 lg:top-96"
        >
          <div className="container mx-auto">
            <div className="lg:-mt-24 min-h-[590px] z-30 mb-8 md:mb-4xl:mb-16">
              <div className="grid grid-cols-1 lg:grid-cols-4 min-h-[590px]">
                {menuItems.map((mi, i) => (
                  <MenuCard
                    index={i}
                    name={mi.name}
                    image={mi.image}
                    price={mi.price}
                    description={mi.description}
                  />
                ))}
              </div>
            </div>

            <button className="btn mx-auto capitalize">{btnText}</button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
